import axios from 'axios';
import router from '@/router/index.js'
import Vue from 'vue'
import bootbox from 'bootbox';
import VueI18n from 'vue-i18n'
import {store} from "@/javascript/store.js";

var permissions = [];
var loggedIn = false;
var heartbeat;

var Auth = {	
	install: function (Vue, options) {
		var auth = {
	    	isLoggedIn: isLoggedIn,
	    	login: login,
	    	loginAs: loginAs,
	    	logout: logout,
			hasPermission: hasPermission,
			getCookieValue: getCookieValue
	    };    	
	    
		Vue.$auth = auth;
		Vue.prototype.$auth = auth;
	}
}

Vue.use(Auth)

function isLoggedIn(){
	return loggedIn;
}

function login(_permissions, user) {
	store.user = user;
	permissions = _permissions;
	loggedIn = true;
	Vue.$eventBus.$emit("login");
	axios.defaults.headers.common = {'xsrf-token': getCookieValue('xsrf-token')};
	
	startHeartbeat();
}

function logout(redirect) {
	axios
	.post('login/logout/')
	.then(response => {
		permissions = [];
		loggedIn = false;
		Vue.$eventBus.$emit("logout");
		delete axios.defaults.headers.common["xsrf-token"];
		store.user = {"id": -1, "login": ""};
		if(redirect) {
			router.replace({path: '/login', query: {redirect: router.currentRoute.path}});
		} else {
			router.push({path: '/login'});
		}
		clearInterval(heartbeat);
	 });
}

function getCookieValue(a) {
    var b = document.cookie.match('(^|[^;]+)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}

function startHeartbeat() {
	heartbeat = setInterval(function() {
		renewAccessToken();
	}, 1000 * 60 * 5);
}

function hasPermission() {
	for (var i=0; i < arguments.length; i++) {
		if($.inArray(arguments[i], permissions) >= 0) {
			return true;
		}
	}
		
	if($.inArray("selfUser", arguments) >= 0) {
		let id = router.history.pending !== null ? router.history.pending.params.id : router.currentRoute.params.id;
		if(id == store.user.id) {
			return true;
		} 
	}
	return false;
}

function renewAccessToken() {
	axios
	.post('login/checkLogin/?renew=0')
	.then(response => {
	 })
	 .catch(e => {
 		if(Vue.$globals.getErrorCode(e) === Vue.$cons.ERROR.NOTLOGGEDIN) {
  	  		bootbox.alert("Sie sind nicht mehr auf dem System angemeldet. Melden Sie sich bitte neu an.", () => {
  				logout(true);
	  		});
 		}
 	});
}

function loginAs(userId){
  axios
    .post('login/loginAs', {
      userId: userId
    })
    .then(response => {
    	permissions = response.data.permissions;
    	store.user = response.data.user;
    	loggedIn = true;
    	Vue.$eventBus.$emit("login");
    	router.push('/');
    	
    })
}


// WEBPACK FOOTER //
// ./src/javascript/plugins/auth.js